// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"19e4190d","764":"ebd88303","867":"34b0cb5f","959":"98501946"}[chunkId] + ".chunk.js";
};